function initSubscriptionComponent(widgetParent) {
    const subsContainer = document.querySelector('.js-sbs-container');
    const otpContainer = document.querySelector('.js-otp-container');

    const subsContainerRecharge = widgetParent.querySelector('.subscription-radio');
    const otpContainerRecharge = widgetParent.querySelector('.onetime-radio');
    const inputSbsRadio = document.querySelector('.js-sbs-input-radio');
    const inputOtpRadio = document.querySelector('.js-otp-input-radio');
    const otpOriginalPriceContainer = document.querySelector('.price_otp.js-price-otp')
    const subOriginalPriceContainer = document.querySelector('.original-price')
    const subCurrPriceContainer = document.querySelector('.price-sbs.js-price-autoship')
     
    const shadeBtns = document.querySelectorAll('.clickyboxes li');
    const shadeOptions = document.querySelectorAll('select[data-colour-swatch] option');


    subsContainer.addEventListener('click', function () {
        if (this.classList.contains('disabled-subs')) {
            this.classList.add('enabled-subs');
            this.classList.remove('disabled-subs');
            if (inputSbsRadio.classList.contains('sbs-input-radio-disactive')) {
                inputSbsRadio.classList.remove('sbs-input-radio-disactive')
            }
        }

        otpContainer.classList.add('disabled-subs');
        otpContainer.classList.remove('enabled-subs');
        inputOtpRadio.classList.add('sbs-input-radio-disactive');
        subsContainerRecharge.click();
    });

    otpContainer.addEventListener('click', function () {
        if (this.classList.contains('disabled-subs')) {
            this.classList.add('enabled-subs');
            this.classList.remove('disabled-subs');
            if (inputOtpRadio.classList.contains('sbs-input-radio-disactive')) {
                inputOtpRadio.classList.remove('sbs-input-radio-disactive')
            }
        }

        subsContainer.classList.add('disabled-subs');
        subsContainer.classList.remove('enabled-subs');
        inputSbsRadio.classList.add('sbs-input-radio-disactive');
        otpContainerRecharge.click()
        priceSbs.innerText = sbsPriceRecharge.innerText;
    });

    Array.from(shadeBtns).forEach((shade, index) => {
        if(shade.getAttribute('data-listening-shadow-change')) return;
        shade.addEventListener('click', function () {
            
            const shadeOriginalPrice = shadeOptions[index].getAttribute('data-original-price');
            const shadeSubsPrices = shadeOptions[index].getAttribute('data-discount-prices')?.split(',');
            const selectedPlan =  document.querySelector('.rc_widget__option__plans__dropdown.replaced').value;
            const plans =  Array.from(document.querySelectorAll('.rc_widget__option__plans__dropdown option')).map(option => option.value);
            const selectedPlanIndex = plans.indexOf(selectedPlan); 
            const discountPrice = shadeSubsPrices[selectedPlanIndex];

            otpOriginalPriceContainer.innerText = shadeOriginalPrice;
            subOriginalPriceContainer.innerText = shadeOriginalPrice;
            subCurrPriceContainer.innerText = discountPrice;

        })
        shade.setAttribute('data-listening-shadow-change', true);
    });

}

function handleChange(option) {
    let inputSellingPlan = document.querySelector('input[name="selling_plan"]');
    inputSellingPlan.value = option.value;
}

document.addEventListener('DOMContentLoaded', function () {

    let count = 0;
    let sbsOtpContainer = document.querySelector('.sbs-otp-container');
    let widgetParent = document.querySelector('.shopify-block.shopify-app-block.recharge-subscription-widget');

    let interval = setInterval(() => {

        let widgetOptions = document.querySelector('.rc-widget .rc-radio');
        if (widgetOptions) {
            sbsOtpContainer.classList.add('active');
            initSubscriptionComponent(widgetParent);
            clearInterval(interval)
        } else {
            count++
            if (count === 20) {
                clearInterval(interval)
            }
        }
    }, 500)

});